import { render, staticRenderFns } from "./404.vue?vue&type=template&id=227de02d&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"
import style0 from "./404.vue?vue&type=style&index=0&id=227de02d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../omniscient/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227de02d",
  null
  
)

export default component.exports